<template>
  <polygon
    id="close"
    :fill="iconColor"
    transform="translate(12.000000, 12.000000) rotate(45.000000) translate(-12.000000, -12.000000) "
    points="13.4737596 10.5262404 20.4741176 10.5262404 20.4741176 13.4737596 13.4737596 13.4737596 13.4737596 20.4741176 10.5262404 20.4741176 10.5262404 13.4737596 3.52588235 13.4737596 3.52588235 10.5262404 10.5262404 10.5262404 10.5262404 3.52588235 13.4737596 3.52588235"
  />
</template>

<script>
export default {
    name: 'CloseIcon',
    props: {
        iconColor: {
            type: String,
            default: 'currentColor'
        }
    }
};
</script>

<style scoped></style>
